// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___39eVi","description":"styles__description___2Une3","container":"styles__container___1VACa"};